import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=6f3e8494&scoped=true&"
import script from "./userCard.vue?vue&type=script&lang=js&"
export * from "./userCard.vue?vue&type=script&lang=js&"
import style0 from "./userCard.vue?vue&type=style&index=0&id=6f3e8494&scoped=true&lang=css&"
import style1 from "./userCard.vue?vue&type=style&index=1&id=6f3e8494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e8494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3e8494')) {
      api.createRecord('6f3e8494', component.options)
    } else {
      api.reload('6f3e8494', component.options)
    }
    module.hot.accept("./userCard.vue?vue&type=template&id=6f3e8494&scoped=true&", function () {
      api.rerender('6f3e8494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personalCenter/components/userCard.vue"
export default component.exports